import { css, mq, spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { Button, ErrorMessage, SafeHtml } from '@thg-commerce/gravity-elements'
import { TextStyling } from '@thg-commerce/gravity-theme/typography/typography'

export const StyledLi = styled.li<{ lastItem?: boolean }>`
  margin-top: 0;
  border: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  ${(props) => !props.lastItem && `border-bottom: none;`}
`

export const StyledMenuTitle = styled.h2<{ textStyle?: TextStyling }>`
  ${(props) =>
    Text(
      props.textStyle?.entry || 'medium1',
      props.textStyle?.style || 'alternate',
    )};
  margin: ${spacing(5)} 0 ${spacing(1)} 0;
`

export const BuildYourOwnBundleContainer = styled.div`
  margin: 0 auto;
  max-width: ${(props) => props.theme.site.siteWidth};
  position: relative;
  padding: 0 ${spacing(1)};
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    padding: 0 ${spacing(3)};
  }
  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    padding: 0 ${spacing(4)};
  }
`

export const StyledTotalTitle = styled.h2<{ textStyle?: TextStyling }>`
  ${(props) =>
    Text(
      props.textStyle?.entry || 'medium1',
      props.textStyle?.style || 'alternate',
    )};
  margin-bottom: ${spacing(1)};
`

export const TitleContainer = styled.div`
  width: 100%;
  margin-bottom: ${spacing(5)};
  padding: 0 ${spacing(1)};
`

export const Title = styled(SafeHtml)<{ textStyle?: TextStyling }>`
  ${(props) =>
    Text(
      props.textStyle?.entry || 'xlarge1',
      props.textStyle?.style || 'default',
    )};
  word-break: break-word;
  margin-bottom: ${spacing(2)};
`

export const Subtitle = styled(SafeHtml)<{ textStyle?: TextStyling }>`
  ${(props) =>
    Text(
      props.textStyle?.entry || 'bodyText',
      props.textStyle?.style || 'alternate',
    )};
  width: 100%;
`

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: ${spacing(5)};
`

export const StyledLeftMenu = styled.div`
  display: none;
  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    display: flex;
    flex-direction: column;
    padding-bottom: ${spacing(8)};
    width: 300px;
    margin-right: ${spacing(4)};
    position: sticky;
    top: 150px;
    height: 100%;
  }
`

const activeLiStyle = css`
  background-color: ${(props) => props.theme.colors.palette.brand.lightest};
  &:before {
    content: '';
    width: 4px;
    height: 100%;
    display: inline-block;
    left: 0;
    top: 0;
    position: absolute;
    background-color: ${(props) => props.theme.colors.palette.brand.base};
  }
`

export const StyledButton = styled.button<{ active?: boolean }>`
  ${Text('bodyText', 'default')};
  position: relative;
  transition: background-color 0.3s ease;
  padding: ${spacing(1.5)} ${spacing(2)};
  width: 100%;
  text-align: left;
  &:hover {
    background-color: ${(props) => props.theme.colors.palette.brand.lightest};
  }
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(1.5)} ${spacing(2)};
    ${(props) => props.active && activeLiStyle}
  }
`

export const TotalReceiptBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${spacing(2)};
  border: 1px solid ${(props) => props.theme.colors.palette.greys.light};
`

export const TotalContent = styled.div`
  width: 100%;
  margin-top: ${spacing(1)};
  text-align: center;
`

export const TotalContentText = styled.span`
  ${Text('small', 'default')};
`

export const AddToBasketErrorMessage = styled(ErrorMessage)`
  margin-bottom: ${spacing(4)};
`

export const TotalContentPrice = styled.h2`
  ${Text('medium1', 'default')};
  margin-top: ${spacing(1)};
  margin-bottom: ${spacing(2)};
`

export const AddTotalToBasket = styled(Button)`
  width: 100%;
  button,
  button:hover,
  button:focus,
  button:disabled,
  button:active {
    padding-left: ${spacing(0.5)};
    padding-right: ${spacing(0.5)};
  }
`
